import Link from "next/link";
import useImageSize from "../../../../hooks/global/useImageSize";
import { IListingCollabImage } from "../../../../interfaces/training-plan/material/collaborators/IListingCollabImage";
import { ListingRoundedImage } from "../listingRoundedImage/ListingRoundedImage";

export const ListingCollabImage = ({
  data,
  className,
}: IListingCollabImage) => {
  const [resizedProfileImage] = useImageSize({
    size: 150,
    imageUrl: data.imageUrl,
    isProfile: true,
    originalFormat: true,
  });

  return (
    <Link href={data.link ?? "/"}>
      <ListingRoundedImage
        title={data.title}
        image={resizedProfileImage}
        useBorder={false}
        className={`w-[3.125rem] h-[3.125rem] ${className}`}
      />
    </Link>
  );
};
